import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, Typography, Table, TableBody, TableCell, TableHead, TableRow, Grid, TextField, Button } from '@material-ui/core';
import './Checkout.css';

// Components
import Header from '../Components/Header';
import { firebaseSdk } from '../Firebase/Init';

function Checkout() {
    const [form, setForm] = useState({
        address: '',
        city: '',
        province: '',
        postal_code: '',
        phone: ''
    })
    const history = useHistory();
    const cart = JSON.parse(localStorage.getItem('cart'));

    // Calculate cart total
    const getCartTotal = () => {
        let currentTotal = 0;
        for (const item of cart) {
            let quantitativeTotal = item.price * item.quantity;

            currentTotal = currentTotal + quantitativeTotal;
        }

        return currentTotal;
    }

    const total = getCartTotal();

    // Handle form change
    const handleFormChange = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    }

    // Handle submit form
    const handleSubmit = () => {
        console.log(form);
        console.log(cart);

        // Build data to send
        const transactionObjToSend = {
            menu_id_items: [
                {
                    id: 0,
                    quantity: cart[0].quantity
                },
                {
                    id: 1,
                    quantity: cart[1].quantity
                },
                {
                    id: 2,
                    quantitiy: cart[2].quantity
                }
            ],
            user_id: JSON.parse(localStorage.getItem('user')).user.uid
        }
        const userObjToSend = {
            address: form.address,
            city: form.city,
            phone: form.phone,
            postal_code: form.postal_code,
            province: form.province,
            user_id: JSON.parse(localStorage.getItem('user')).user.uid
        }

        // Add data to backend
        firebaseSdk.database().ref('/transaction_history').push(transactionObjToSend)
            .then(() => saveUserData(userObjToSend)).catch(() => alert('Error'));
    }

    const saveUserData = (data) => {
        firebaseSdk.database().ref('/user_data').push(data)
            .then(() => history.push('/Home')).catch(() => alert('Error'));
    }

    // Go back to ordering
    const handleBack = () => {
        localStorage.removeItem('cart');
        history.push('/Home');
    }

    return (
        <div>
            <Header title="Checkout" />
            <div className="content-body padding-2x padding-2y">
                <Card className='padding-2x padding-2y margin-2y'>
                    <Typography variant="h5">Cart</Typography>
                    <br /><br />
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Item</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { cart.map((item, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{item.quantity}</TableCell>
                                        <TableCell>${item.quantity * item.price}</TableCell>
                                    </TableRow>
                                )
                            })
                            }
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Total</TableCell>
                                <TableCell>${total}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Card>

                <Card className="padding-2x padding-2y margin-2y">
                    <Typography variant="h5">Contact information</Typography>
                    <br /><br />
                    <Grid container>
                        <Grid item xs={6}>
                            <TextField name="address" label="Address" onChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField name="city" label="City" onChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField name="province" label="Province" onChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField name="postal_code" label="Postal Code" onChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField name="phone" label="Phone" onChange={handleFormChange} />
                        </Grid>
                    </Grid>
                </Card>

                <Button className="margin-right-2x" variant="contained" color="secondary" onClick={handleSubmit}>Submit Order</Button>

                <Button variant="contained" color="primary" onClick={handleBack}>Cancel</Button>
            </div>
        </div>
    );
}

export default Checkout;